import api from '@/lib/axios';
import type { OrganizationDto } from '@/types/tenant';

/**
 * Sets an organization's logo. `path` is the bucket-prefixed GCS path produced by
 * file-management-service (the upload response's `bucketPath` field) — posted
 * verbatim. Backend regex-validates `^(/[A-Za-z0-9_][A-Za-z0-9._\-]*){2,}$`.
 *
 * IDOR rule: path-param `id` must equal the caller's `X-Organization-Id` (gateway-injected).
 * Workpay-org callers bypass via `X-Organization-Type=WORKPAY` and may update any org.
 * 404 on cross-tenant access — never 403, to avoid existence leak.
 *
 * Permission: `ORGANIZATIONS_UPDATE`.
 */
export const setOrganizationProfileImage = async (
  id: string,
  path: string,
): Promise<OrganizationDto> => {
  const response = await api.put<OrganizationDto>(
    `/platform-service/v1/organizations/${id}/profile-image`,
    { path },
    { successToast: true },
  );
  return response.data;
};

export const clearOrganizationProfileImage = async (id: string): Promise<OrganizationDto> => {
  const response = await api.delete<OrganizationDto>(
    `/platform-service/v1/organizations/${id}/profile-image`,
    { successToast: true },
  );
  return response.data;
};
